import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MessageBox, ProblemMenuSelection } from 'src/app/store/application';

@Component({
  selector: 'app-problem-message-info',
  templateUrl: './problem-message-info.component.html',
  styleUrls: ['./problem-message-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProblemMessageInfoComponent implements OnInit {
  @Input() selectedProblemMenuItem: ProblemMenuSelection | null;
  @Input() showRedirectionMsg: boolean;
  @Input() showIsUrgentPrompt: boolean;

  headerBannerMsg = "";
  generalMessage = "";
  addressLink = "";
  messageBox: MessageBox[] = [];

  isTreePermitOverride: boolean = false;
  isTreeSafetyNeeded: boolean = false;

  constructor() { }

  isTreePermitOverrideRequired(menuId?: number) {
    switch (menuId) {
      case 65:
      case 68:
        return true;

      default:
        return false;
    }
  }

  setIsTreeSafetyNeeded(menuId?: number) {
    switch (menuId) {
      case 116:
      case 117:
      case 66:
      case 72:
      case 93:
      case 73:
        this.isTreeSafetyNeeded = true;
        break;

      default:
        this.isTreeSafetyNeeded = false;
        break;
    }
  }

  ngOnInit(): void {
    if (this.isTreePermitOverrideRequired(this.selectedProblemMenuItem?.ProblemMenuConfig_RefId)) {
      this.isTreePermitOverride = true;
    }

    this.setIsTreeSafetyNeeded(this.selectedProblemMenuItem?.ProblemMenuConfig_RefId);

    if (!this.showRedirectionMsg) {
      this.headerBannerMsg = "Is this urgent?";

      switch (this.selectedProblemMenuItem?.ProblemMenuConfig_RefId) {
        case 141: 
        case 16:
        case 83:
          this.generalMessage = `If the problem you're reporting relates to a pollution issue in a creek, it's important that we know about it right away. <br>
          If so, please call us immediately at the number below:`;

          this.messageBox.push({
            title: "Weekends, Holidays and After Hours",
            titleInfo: "",
            message: "604-990-3666"
          })
          break;

        // case 7:
        case 50:
        case 52:
          this.generalMessage = `If the problem that you're reporting is an emergency or requires immediate attention, it's important that we know about it right away.<br>
          If so, please call us immediately at the appropriate number below:`;

          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 51:
          this.generalMessage = `If the problem you're reporting relates to a <strong>STOP</strong>, <strong>YIELD</strong>, or <strong>PEDESTRIAN CROSSING</strong> sign, it's important that we know about it right away.<br>
          If so, please call us immediately at the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 116:
        case 117:
          this.generalMessage = `If the problem you're reporting relates to one of the following, it's also important that we know right away:
          <ul>
            <li>Motor vehicle accident involving tree(s)</li>
            <li>Tree causing damage to house or car</li>
            <li>Tree causing injury to person</li>
            <li>Tree on fire or fallen on wire</li>
            <li>Tree on road blocking traffic</li>
          </ul>
          
          If so, please call us immediately at the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 66:
        case 73:
          this.generalMessage = `If the problem you're reporting relates to one of the following, it's also important that we know right away:
          <ul>
            <li>Illegal tree cutting or damage in progress</li>
            <li>Motor vehicle accident involving tree(s)</li>
            <li>Tree causing damage to house or car</li>
            <li>Tree causing injury to person</li>
            <li>Tree on fire or fallen on wire</li>
            <li>Tree on road blocking traffic</li>
          </ul>
          
          If so, please call us immediately at the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 72:
        case 93:
          this.generalMessage = `If the problem you're reporting relates to illegal tree cutting or damage <b>in progress</b>, it's also important that we know right away.<br>
          If so, please call us immediately at the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        // case 68:
        //   this.headerBannerMsg = "Apply for Tree Permit";
        //   this.addressLink = "https://www.dnv.org/permits-licenses/tree-permit";
        //   this.generalMessage = `You will need a tree permit if you want to do any work on a tree that is protected. To find out if your tree is protected, see examples on our <a href="${this.addressLink}" target="_blank">tree permit page</a>.<br>
        //   Full details on what can be done without a permit, when a permit is required, and how to apply for a permit can be found on our <a href="${this.addressLink}" target="_blank">tree permit page</a>.<br>
        //   For any further questions about your concern about this matter, contact us at <a href="mailto:environment@dnv.org?subject=Tree Permit Inquiry">environment@dnv.org</a>.`

        //   this.messageBox.push({
        //     title: "Weekends, Holidays and After Hours",
        //     titleInfo: "",
        //     message: "604-990-3666"
        //   });
        //   break;

        default:
          break;
      }

    } else {
      switch (this.selectedProblemMenuItem?.ProblemMenuConfig_RefId) {
        case 6:
          this.headerBannerMsg = "Call BC SPCA";
          this.generalMessage = `Please contact the SPCA for stray or injured cats or other animals.`;

          this.messageBox.push({
            title: "BC SPCA",
            titleInfo: "(Everyday 8:00am to 6:00pm)",
            message: "604-922-4622"
          });
          break;

        case 75:
        case 76:
        case 77:
        case 78:
        case 91:
          this.headerBannerMsg = "Call DNV";
          this.generalMessage = `You are filing a report after hours that could potentially be an emergency.<br>
          Please contact the District directly using the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 79:
          this.headerBannerMsg = "Call DNV";
          this.generalMessage = `You are filing a report that could potentially be an emergency.<br>
          Please contact the District directly using the appropriate number below:`;
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 86:
          this.headerBannerMsg = "Contact Emterra";
          this.generalMessage = `Emterra is responsible for all residential recycling.<br>
          For recycling issues, contact Emterra at:`;
          
          this.messageBox.push(
            {
              title: "Emterra",
              titleInfo: "",
              message: `778-589-3221 or <a href='mailto:NV.CSR@emterra.ca?subject=Recycling not collected'>NV.CSR@emterra.ca</a>`
            }
          );
          break;

        case 100:
          this.headerBannerMsg = "Report elsewhere on DNV";
          this.addressLink = "https://www.dnv.org/your-home-property/request-repairs-your-carts-or-report-lost-or-stolen-cart";
          this.generalMessage = `Please report damaged or missing carts at <a href="${this.addressLink}" target="_blank">${this.addressLink}</a>`
          this.messageBox.push(
            {
              title: "Weekdays",
              titleInfo: "(8:00am - 4:30pm)",
              message: "604-990-2311"
            },
            {
              title: "Weekends, Holidays and After Hours",
              titleInfo: "",
              message: "604-990-3666"
            }
          );
          break;

        case 65:
        case 68:
          this.headerBannerMsg = "Apply for Tree Permit";
          this.addressLink = "https://www.dnv.org/permits-licenses/tree-permit";
          this.generalMessage = `You will need a tree permit if you want to do any work on a tree that is protected. To find out if your tree is protected, see examples on our <a href="${this.addressLink}" target="_blank">tree permit page</a>.<br>
          Full details on what can be done without a permit, when a permit is required, and how to apply for a permit can be found on our <a href="${this.addressLink}" target="_blank">tree permit page</a>.<br>
          For any further questions about your concern about this matter, contact us at <a href="mailto:environment@dnv.org?subject=Tree Permit Inquiry">environment@dnv.org</a>.`
          break;

        default:
          break;
      }
    }
  }

}
